import Layout from "./layout"
import React from "react"
import ListaDeCategoriasYProductos from "./lista-de-categorias-y-productos"
import Camino from "./camino"
import { useStaticQuery, graphql } from "gatsby"
import FotosYCarrousel from "./fotos-y-carrousel"
import Paper from "@material-ui/core/Paper"
import styled from "@emotion/styled"
import { Typography } from "@material-ui/core"
import Spacer from "./spacer"
import Docs from "./docs"
//import Comentarios from "./comentarios"

const GalleryWrapper = styled.div``
const convertToRig = pageNode => {
  // original: item.node.orgsrc,
  // description: item.node.dscrpt,
  // embedUrl: item.node.mbdurl,
  // originalClass: 'imagen-en-carrousel',
  // originalTitle: item.node.dscrpt,
  // fluid: item.node.origen.childImageSharp.fluid,
  return pageNode.frontmatter.galeria
    .filter(item => Boolean(item.source))
    .map(item => ({
      original: item.source.childImageSharp.fluid.originalName,
      description: item.descripcion,
      embedUrl: undefined,
      originalClass: "imagen-en-carrousel",
      originalTitle: item.descripcion,
      thumbnail: item.source.childImageSharp.fixed.src,
      fluid: item.source.childImageSharp.fluid,
    }))
}
const ProductsPageLayout = props => {
  const slug = props.path.replace("/content/productos/", "").replace(/\/$/, "")
  const data = useStaticQuery(graphql`
    {
      productos: allMdx {
        edges {
          node {
            excerpt(pruneLength: 256)
            fileAbsolutePath
            id
            slug
            frontmatter {
              puesto
              author
              avatar
              date(formatString: "DD MMMM YYYY")
              documentos {
                nombre
                origen {
                  publicURL
                }
              }
              galeria {
                descripcion
                source {
                  absolutePath
                  childImageSharp {
                    fluid(maxWidth: 800) {
                      ...GatsbyImageSharpFluid
                      originalName
                      src
                      sizes
                    }
                    fixed(width: 150) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
              imagen {
                descripcion
                source {
                  childImageSharp {
                    fluid(maxWidth: 800) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
              title
              subtitle
            }
            timeToRead
          }
        }
      }
      avatares: allAvataresYaml {
        nodes {
          nombre
          source {
            absolutePath
            name
            extension
            childImageSharp {
              fixed {
                base64
                originalName
                src
              }
              original {
                src
              }
            }
            base
            root
            relativeDirectory
            relativePath
          }
        }
      }
    }
  `)
  const pageEdge = data.productos.edges.filter(e =>
    e.node.fileAbsolutePath.includes(
      props.uri !== "/" ? props.uri + ".mdx" : ""
    )
  )[0]
  const pageNode = pageEdge ? pageEdge.node : undefined
  const sub =
    props.pageContext &&
    props.pageContext.frontmatter.subtitle &&
    props.pageContext.frontmatter.subtitle.length > 0
      ? props.pageContext.frontmatter.subtitle
      : " "
  return (
    <Layout>
      <Camino slug={slug} />

      <Spacer pixels={16} />

      <Typography variant="h4" component="h4" color="primary">
        {props.pageContext.frontmatter.title}
      </Typography>
      <div style={{ opacity: 0.6 }}>{sub}</div>

      <Spacer pixels={16} />

      {pageNode.frontmatter.galeria &&
      pageNode.frontmatter.galeria.length > 0 ? (
        <Paper elevation={2} square style={{ padding: "0 8px" }}>
          <GalleryWrapper>
            <FotosYCarrousel lista={convertToRig(pageNode)} />
          </GalleryWrapper>
        </Paper>
      ) : (
        <span></span>
      )}
      {pageNode.frontmatter.documentos ? (
        <Docs documentos={pageNode.frontmatter.documentos} />
      ) : null}
      {props.children}
      <ListaDeCategoriasYProductos slug={slug} avatares={data.avatares.nodes} />

      <Spacer pixels={8} />
      {/* <Comentarios /> */}
    </Layout>
  )
}
export default ProductsPageLayout
